import { error, finish } from '../../../modules/related-contingency/actions/update-related-contingency';
import { request as getAllRcTags } from '../../../modules/related-contingency/actions/get-related-contingency';
import api from '../../../api';

export function request(dispatch, { data }) {
    api.put('/contingencies/tag-management', data)
        .then(res => {
            dispatch(finish(res));
            dispatch(getAllRcTags());
        }).catch(err => {
            dispatch(error(err));
        });
}
